import { defineStore } from 'pinia';
import { PurchaseOrderDto, PurchaseOrderListItemDto } from '@containex/portal-backend-dto';
import { computed, ref } from 'vue';

export const useOrderStore = defineStore('purchase-order', () => {
    const orders = ref<PurchaseOrderListItemDto[]>([]);
    const order = ref<PurchaseOrderDto | null>(null);
    const orderCompletedDialogIsVisible = ref(false);

    return {
        orders: computed(() => orders.value),
        order: computed(() => order.value),
        orderCompletedDialogIsVisible: computed(() => orderCompletedDialogIsVisible.value),
        setOrders(data: PurchaseOrderListItemDto[]): void {
            orders.value = data;
        },
        setOrder(data: PurchaseOrderDto | null): void {
            order.value = data;
        },
        setOrderCompletedDialogIsVisible(isVisible: boolean): void {
            orderCompletedDialogIsVisible.value = isVisible;
        },
    };
});
